import { httpClient } from '@/shared/services/HttpClient';
import qs from 'qs';

class EstateAgentReviewService {
  url = 'operation/estateagentreview';

  getByEstateAgent(frontUserId: number): any {
    return httpClient.get(this.url + '/' + frontUserId);
  }

  getById(adId: number): any {
    const qsString = qs.stringify({ adId }, { skipNulls: true, encodeValuesOnly: true });
    return httpClient.get(this.url + '?' + qsString);
  }

  request(data: any): any {
    return httpClient.post(this.url + '/request', data);
  }

  publish(data: any): any {
    return httpClient.post(this.url + '/publish', data);
  }

  insert(data: any): any {
    return httpClient.post(this.url, data);
  }

  delete(estateAgentReviewId: number): any {
    return httpClient.delete(this.url + '/' + estateAgentReviewId);
  }

  getRequest(token: string): any {
    const qsString = qs.stringify({ token }, { skipNulls: true, encodeValuesOnly: true });
    return httpClient.get(this.url + '/request?' + qsString);
  }
}

const estateAgentReviewService = new EstateAgentReviewService();

export { estateAgentReviewService };
